import React from 'react'
import { Paper, Typography } from '@mui/material'
import NextLink from '@imports/NextLink'

function ArticleCard({ article, showCategory = false }) {
  return (
    <NextLink href={`/help-center/${article.slug}`}>
      <Paper
        sx={{
          height: '100%',
          p: 4,
          boxShadow: 0,
          backgroundColor: 'transparent',
          cursor: 'pointer',
          transition: (theme) =>
            theme.transitions.create(['background-color', 'box-shadow'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          ':hover': {
            backgroundColor: 'paper.main',
            boxShadow: 1,
          },
        }}
      >
        <Typography
          display="block"
          gutterBottom
          variant="body2"
          fontWeight={700}
        >
          {!!showCategory && (
            <Typography
              display="block"
              gutterBottom
              variant="caption"
              component="span"
              fontWeight={400}
              fontSize={14}
              color="primary.main"
            >
              {article.category.title}
            </Typography>
          )}
          {article.title}
        </Typography>
        <Typography
          display="block"
          gutterBottom
          variant="caption"
          fontSize={14}
          fontWeight={400}
          color="neutral.dark"
        >
          {article.description}
        </Typography>
      </Paper>
    </NextLink>
  )
}

export default ArticleCard
